<template>
  <div class="marquee-container" @mouseenter="startMarquee" @mouseleave="stopMarquee">
    <!-- Texto Animado -->
    <div v-if="isHovered" :class="['marquee-content', { 'is-scrolling-infinite': isHovered && infiniteOnHover, 'is-scrolling-once': isHovered && !infiniteOnHover && !hasLooped }]" :style="animationStyle" @animationend="handleAnimationEnd">
      <span class="marquee-text" ref="marqueeText">{{ text }}</span>
      <div v-if="infiniteOnHover">
        <span v-for="n in textRepetitions" :key="n" class="marquee-text"> {{ text }} </span>
      </div>
    </div>
    <!-- Texto Estático -->
    <div v-else class="marquee-content static">
      <span class="marquee-text" ref="marqueeText">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Fallback Text',
    },
    infiniteOnHover: {
      type: Boolean,
      default: true,
    },
    textRepetitions: {
      type: Number,
      default: 3,
    },
    speed: {
      type: Number,
      default: 3.5,
    },
  },
  data() {
    return {
      isHovered: false,
      hasLooped: false,
      textWidth: 0,
    };
  },
  computed: {
    animationStyle() {
      return {
        '--marquee-speed': `${this.infiniteOnHover ? this.speed * 5.5 : this.speed}s`,
        '--text-width': `${this.textWidth}px`,
        '--repetitions': `${this.textRepetitions}`,
      };
    },
  },
  watch: {
    isHovered(newValue) {
      if (!newValue) {
        this.hasLooped = false;
      }
    },
  },
  mounted() {
    this.measureTextWidth();
    window.addEventListener('resize', this.measureTextWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureTextWidth);
  },
  methods: {
    measureTextWidth() {
      if (this.$refs.marqueeText) {
        this.textWidth = this.$refs.marqueeText.offsetWidth;
      }
    },
    startMarquee() {
      this.isHovered = true;
      this.measureTextWidth();
    },
    stopMarquee() {
      this.isHovered = false;
    },
    handleAnimationEnd() {
      if (!this.infiniteOnHover) {
        this.hasLooped = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.marquee-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;

  .marquee-content {
    display: flex;
    white-space: nowrap;

    &.static {
      transform: translateX(0);
    }

    &.is-scrolling-infinite {
      animation: scroll-infinite var(--marquee-speed) linear infinite;
    }

    &.is-scrolling-once {
      animation: scroll-once var(--marquee-speed) linear 1;
    }

    .marquee-text {
      flex-shrink: 0;
      padding-right: 12px;
    }
  }
}

@keyframes scroll-infinite {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-1 * var(--repetitions) * (var(--text-width) + 12px)));
  }
}

@keyframes scroll-once {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}
</style>
